<div v-bind:class="useClassName">
  <!-- <button
  v-if="getAttribute('showRearrange')"
  type="button"
  class="btn btn-primary matrix_uploadButtonRearrange"
  @click="uploadOnRearrange(propsData.code)"
>
</button>
<button
type="button"
class="btn btn-primary matrix_uploadButtonPreview"
@click="uploadOnPreview(propsData.code)"
v-if="getShowPreviewInUpload && getAttribute('previewFile')"
>
</button> -->
  <button v-if="wasPreflightExecutedSuccessfully()" :disabled="areLinksExpired" type="button" class="btn btn-primary matrix_uploadButtonDownload" 
  @click="openUrlToDownload(getUploadedFileUrl('ArtworkFile'))">
    <div :class="getClassName + 'ButtonIconContainer'">
      <img :class="getClassName + 'PrintPreviewIcon'" :src="this.getBaseUrl + '/images/matrix/print_preview.png'"/>
    </div> 
    <span :class="getClassName + 'ButtonText'">{{ $t("Print Preview PDF") }}</span>
  </button>
  <button v-show="0" :disabled="areLinksExpired" type="button" class="btn btn-primary matrix_uploadButtonPrintPreview">
    <div :class="getClassName + 'ButtonIconContainer'">
     <img :class="getClassName + 'PrintPreviewIcon'" :src="this.getBaseUrl + '/images/matrix/preview_render.png'"/>
    </div>
    <span :class="getClassName + 'ButtonText'">{{ $t("Print Preview Render") }}</span>
  </button>
  <button v-show="0" :disabled="areLinksExpired" type="button" class="btn btn-primary matrix_uploadButtonFlatplan" >
    <div :class="getClassName + 'ButtonIconContainer'">
      <img :class="getClassName + 'FlatplanIcon'" :src="this.getBaseUrl + '/images/matrix/flatplan_view.png'"/>
    </div>
    <span :class="getClassName + 'ButtonText'">{{ $t("Flatplan view") }}</span>
  </button>
  <button type="button" 
      class="btn btn-primary matrix_uploadButtonDelete"             
      v-if="showDeleteButton"
      @click="uploadOnDelete(propsData.code)">
      <div :class="getClassName + 'ButtonIconContainer'">
       <img :class="getClassName + 'DeleteUploadIcon'" :src="this.getBaseUrl + '/images/matrix/upload.png'"/>
      </div>
      <span :class="getClassName + 'ButtonText'">{{ $t("Upload a New File") }}</span>
  </button>
 

  <!-- <button
    v-if="getAttribute('pitstopReport')"
    type="button"
    class="btn btn-primary matrix_uploadButtonViewReport"
    @click="uploadOnViewReport(propsData.code)"
  >
    {{$t('View report')}}
  </button> -->
</div>